export default "__VITE_ASSET__BMkDwlR2__"